import gql from 'graphql-tag';

import { client } from "../../../App";
import { getDocuments } from "../../../graphql/queries"

// The google maps API doesn't wrap around when going outside of -180 - 180
// For example the longitude of going west from 0, 1.5 times, would be -270 instead of -90
export const boundsWrap = (lng) => {
    if (lng > -180 && lng < 180) {
        return lng
    }
    const multiple = lng / 180
    const rounded = Math.floor(multiple)
    if (lng > 180) {
        if (rounded % 2 === 1) {
            return -(180 - lng % 180)
        } else {
            return (lng % 180)
        }
    } else if (lng < -180) {
        if (rounded % 2 === -1) {
            return (lng % 180)
        } else {
            return 180 + (lng % 180)
        }
    }

}

export const zoomToPrecisionLevel = zoom => {
    let precision = 2

        if (zoom <= 3) precision = 1
        else if (zoom <= 5) precision = 2
        else if (zoom <= 9) precision = 3
        else if (zoom <= 11) precision = 4
        else if (zoom <= 14) precision = 5
        else if (zoom <= 16) precision = 6
        else if (zoom <= 18) precision = 7

    return precision
}

export const fetchDocuments = async (search, precision, topLeft, bottomRight) => { 
    const searchOptions = search.length > 0 ? search : "*"
    try {
        const documents = await client.query({
            query: gql(getDocuments),
            variables: {
                search: searchOptions,
                precision,
                topLeft: {
                    lat: topLeft.lat, lon: boundsWrap(topLeft.lng)
                }, 
                bottomRight: {
                    lat: bottomRight.lat, lon: boundsWrap(bottomRight.lng)
                }},
            fetchPolicy: "no-cache"
        }) 

        // If the documents are locations AKA server side clusters
        const docs = documents.data.getDocuments
        if ( docs.length === 0 ) return { type: "Locations", data: [] }
        if (docs[0].__typename === "Locations") {
            return { type: "Locations", data: docs }
        } else {
            // Otherwise documents are user documents
            const formed = docs.map(user => ({
                type: "Feature",
                properties: {
                    cluster: false, 
                    name: user.name, 
                    tags: user.tags, 
                    imageURL: user.picture,
                    createdAt: user.createdAt,  
                    profileId: user.id,
                    tagFeatured: user.tagFeatured             
                },
                geometry: {
                    type: "Point",
                    coordinates: [
                        user.currentGeopoint.lon,
                        user.currentGeopoint.lat
                    ]
                }
            }))
            return { type: "Users", data: formed }
        } 
    }
    catch (e) {
        console.log(e)
        return []
    }
}

// Compare the previous and new center of the map to see if users need to be fetched again
// Return TRUE: User's should be reloaded
export const shouldReloadUsers = (coord1, coord2) => {
    if (Math.abs(coord1.lat - coord2.lat) > .05 || Math.abs(coord1.lng - coord2.lng) > .05) {
        return true
    }
    return false
}